import React, {useEffect, useState} from 'react'
import {measurementInitValues as initialValues} from '../../models/MeasurementModel'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import axios from 'axios'
import {useLocation} from 'react-router-dom'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import {useIntl} from 'react-intl'
import HeaderCard from '../../../../../../components/Forms/HeaderCard'
import {Parameter} from '../parameter-list/core/_models'
import CreatableSelect from 'react-select/creatable'
import {colourStyles} from '../../../../sga/licenses/components/styles/styles'
import { Toolbar2 } from '../../../../../../_metronic/layout/components/toolbar/Toolbar2'
import { PageTitle } from '../../../../../../_metronic/layout/core'

const API_URL = process.env.REACT_APP_API_URL || 'api'

const measurementSchema = Yup.object().shape({
  value: Yup.array().required('Campo obrigatório'),
})

const FormParameterActionPlanEdit: React.FC = () => {
  const intl = useIntl()
  const location = useLocation()
  const navigate = useNavigate()

  const [selectedAlertDays, setSelectedAlertDays] = useState<number[]>([])
  useEffect(() => {
    console.log('location', location)
    if (location) {
      const {parameter_option, uuid} = location.state as any
      let parameter = []
      for (let i = 0; i < parameter_option.length; i++) {
        const field1: any = {
          value: parseInt(parameter_option[i].value),
          label: parameter_option[i].value,
        }
        parameter.push(field1)
      }
      setSelectedAlertDays(parameter)
      formik.setFieldValue('value', parameter)
      formik.setFieldValue('uuid', uuid)
    }
    // eslint-disable-next-line
  }, [location])

  const handleInputChangeAlertDays = (event: any) => {
    var inputValue = []
    if (event) {
      for (var i = 0; i < event.length; i++) {
        inputValue.push(parseInt(event[i].value))
      }
    }
    setSelectedAlertDays(event)
    formik.setFieldValue('value', inputValue)
  }

  const [loading, setLoading] = useState(false)
  const formik = useFormik<Parameter>({
    initialValues,
    validationSchema: measurementSchema,
    onSubmit: async (values) => {
      setLoading(true)
      console.log('values', values)
      try {
        await axios.post(API_URL + '/v1/parameters/update/' + values.uuid, values)
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'PARAMETERS.SWAL_EDIT'}),
          showConfirmButton: false,
          timer: 2000,
        })
        navigate('/parameters')
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'PARAMETERS.SWAL_EDIT_ERROR'}),
          showConfirmButton: false,
          timer: 2000,
        })

        setLoading(false)
      }
    },
  })

  function resetInputs() {
    formik.resetForm()
  }

  return (
    <div className='card card-custom mt-n8'>
      {/* Component Header de Cadastros. */}
      <Toolbar2 icon={false} subtitle={intl.formatMessage({id: 'COMMON.BACK_BUTTON'})} />
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'PARAMETERS.ACTION_PLAN_EDIT'})}</PageTitle>

      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>

            {/* INICIO NOME ----------------------*/}
            <div className='col-lg-12 d-flex'>
              <label className=' col-lg-2 col-form-label fw-bold required'>
                {intl.formatMessage({id: 'CONTRACT_RENEWAL_NOTICE'})}
              </label>
              <CreatableSelect
                className='form-control form-control-sm form-control-solid p-1 ps-5'
                styles={colourStyles}
                isMulti
                placeholder='Quant. de dias'
                {...formik.getFieldProps('value')}
                value={selectedAlertDays}
                onChange={handleInputChangeAlertDays}
              />
            </div>
            {/* FIM DESCRIÇÃO ------------------------------*/}

            <div className='d-flex justify-content-end py-6'>
              <button type='submit' className='btn btn-sm btn-primary' disabled={loading}>
                {!loading && intl.formatMessage({id: 'COMMON.EDIT_BUTTON'})}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    {intl.formatMessage({id: 'COMMON.EDITING_BUTTON'})}{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
              <button type='reset' onClick={resetInputs} className='btn btn-sm btn-secondary mx-2'>
                {intl.formatMessage({id: 'COMMON.CLEAR_BUTTON'})}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export {FormParameterActionPlanEdit}
